import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  TabIndicator,
} from "@chakra-ui/react";

export function MyReviews() {
  return (
    <div className="contentAdmin">
      <div className="">
        <h2 className="mt-5 mb-2">Reviews and Contributions</h2>
        <p className="text-black">
          Your reviews, questions and answers will appear on the employer’s
          Company Page. They are not associated with your name, CV or job
          applications.
        </p>
      </div>
      <div className="grey-line"></div>
      <div className=" mt-3">
        <Tabs position="relative" variant="unstyled" size={"lg"}>
          <TabList className="flex justify-evenly">
            <Tab className="">Reviews(0)</Tab>
            <Tab className="mx-20">Questions(0)</Tab>
            <Tab>Answers(0)</Tab>
          </TabList>
          <TabIndicator
            mt="-1.5px"
            height="2px"
            bg="blue.500"
            borderradius="1px"
          />
          <TabPanels>
            <TabPanel>
              <div>
                <div className="flex justify-center">
                  <img
                    className="w-60"
                    src="https://in.indeed.com/contributions/static/images/ZRPImagePadlock-0cc227.svg"
                    alt=""
                  />
                </div>
                <div className="text-center">
                  <h3>Unlock all reviews</h3>
                  <p className="text-black mx-5 mt-3">
                    Access all reviews by writing yours.
                  </p>
                  <button className="a-button text-white w-72">
                    Write a review
                  </button>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <p>two!</p>
            </TabPanel>
            <TabPanel>
              <p>three!</p>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </div>
  );
}
